<!-- 本科学员-appointment-activity-详情 -->
<template>
  <div class='appoint-detail'>
    <img :src='appointDetailPic' />
    <div class='detail-right'>
      <!-- <div class='date'>距离开始时间还有：<span>3天15小时</span></div> -->
      <div class='date'>Appointment starts in <span>{{appointInfo.remaining}}</span></div>
      <h3 class='title'>{{appointInfo.module && new Map(packageModuleMap).get(appointInfo.module)}}</h3>
      <div class='detail-main'>
        <div class='main-item'><span class='item-name'>Appointment start time：</span><span class='item-val'>{{appointInfo.mentorResultTimeStr}}（priority）</span></div>
        <div class='main-item'><span class='item-name'>Expected duration：</span><span class='item-val'>{{appointInfo.predictTime}}mins</span></div>
        <div class='main-item'><span class='item-name'>Discussion topic：</span><span class='item-val'>{{appointInfo.title}}</span></div>
        <div class='main-item'><span class='item-name'>Other information：</span><span class='item-val'>{{appointInfo.otherMsg}}</span></div>
      </div>
      <div class='oper-btn'>
        <a href='javascript:void(0)'
           @click='goChat'>Enter the meeting</a>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import appointDetailPic from '@/assets/undergraduate/images/appointment_detail.png'
import appointmentService from '@/api/undergraduate/appointment'
import { packageModuleMap } from './constants'
export default {
  name: '',
  components: {},
  data () {
    return {
      // 预约详情图片
      appointDetailPic,
      // 套餐模块映射
      packageModuleMap,
      // 预约ID
      appintId: -1,
      // 预约详情
      appointInfo: {}
    }
  },
  computed: {},
  mounted () {
    this.appintId = this.$route.params.appointId
    this.getAppointDetail()
  },
  methods: {
    // 获取预约详情
    getAppointDetail () {
      if (this.appintId !== -1) {
        appointmentService.appointDetail({ id: this.appintId }).then(res => {
          this.appointInfo = res.data.model
        }).catch(res => {
          this.$ugd_message(res.message, 'error')
        })
      }
    },
    // 进入聊天室-点击
    goChat () {
      window.open(this.appointInfo.zoom)
    }
  }
}
</script>
<style lang='less' scoped>
.appoint-detail {
  width: 700px;
  padding-top: 60px;
  margin: 0 auto;
  display: flex;
  img {
    display: inline-block;
    border: none;
    flex: 0 0 232px;
    width: 232px;
    height: 124px;
  }
  .detail-right {
    flex: 1;
    padding-left: 40px;
    .date {
      font-size: 14px;
      color: #000;
      span {
        font-size: 20px;
        color: #ff612f;
      }
    }
    .title {
      font-size: 16px;
      color: #323c47;
      padding: 10px 0;
    }
    .detail-main {
      .main-item {
        font-size: 14px;
        color: #667483;
        letter-spacing: 0;
        line-height: 22px;
        position: relative;
        .item-name {
          position: absolute;
          top: 0;
          left: 0;
          width: 180px;
          color: #323c47;
          font-weight: bold;
          text-align: right;
        }
        .item-val {
          display: block;
          padding-left: 180px;
          color: #667483;
        }
      }
    }
    .oper-btn {
      padding-top: 20px;
      a {
        display: block;
        width: 136px;
        height: 32px;
        background-image: linear-gradient(12deg, #4aa6ff 0%, #4980fd 100%);
        border-radius: 8px;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        line-height: 32px;
      }
    }
  }
}
</style>
